import { render, staticRenderFns } from "./DetailComplain.vue?vue&type=template&id=e2d00808&scoped=true&"
import script from "./DetailComplain.vue?vue&type=script&lang=ts&"
export * from "./DetailComplain.vue?vue&type=script&lang=ts&"
import style0 from "./DetailComplain.vue?vue&type=style&index=0&id=e2d00808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d00808",
  null
  
)

export default component.exports